// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"73395fa9","361":"30c065b0","583":"e8ef2567","760":"35686480","832":"797844ea","940":"2cfc6a04","963":"fd449224"}[chunkId] + ".chunk.js";
};